/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lots_EmptyInputs */

const vi_sl_lots_empty = /** @type {(inputs: Sl_Lots_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có lô nào.`)
};

/**

* @param {Sl_Lots_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lots_empty = /** @type {((inputs?: Sl_Lots_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lots_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lots_empty(inputs)
});